import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { Validacoes } from 'src/app/shared/validators/validacao.validator';
import AppResponseError from 'src/app/shared/models/app-response-error';
import { TokenLogin } from 'src/app/shared/models/login-response';
import { TEXTO_TOOLTIP_SENHAS } from 'src/app/shared/util/constants';

@Component({
  selector: 'app-password-setter',
  templateUrl: './password-setter.component.html',
  styleUrls: ['./password-setter.component.scss']
})
export class PasswordSetterComponent implements OnInit {
  private authCode: string;
  private tipo: string;
  formPassword: FormGroup;
  authCodeInvalido = false;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private toastr: ToastrService,
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService) { }

  ngOnInit() {
    this.formPassword = this.fb.group({
      senha: new FormControl(null, [Validators.required, Validators.minLength(8), Validators.maxLength(30), Validacoes.validaNovaSenha]),
      confirmarSenha: new FormControl(null, [Validators.required, Validators.minLength(8), Validators.maxLength(30)])
    }, { validators: Validacoes.arePasswordsEqual('confirmarSenha', 'senha'), updateOn: 'change' });

    this.route.params
      .subscribe({
        next: data => {
          try {
            this.authCode = data.authcode;
            if (!this.authCode) {
              throw {
                titulo: 'Erro',
                descricao: 'Código de autorização não encontrado'
              } as AppResponseError;
            }

            // descobre o tipo da requisição, se é uma recuperação de senha ou uma senha nova
            this.tipo = '';
            try {
              this.tipo = atob(this.authCode).split('|')[1];
              if (!this.tipo) {
                throw new Error();
              }
            } catch {
              throw {
                titulo: 'Erro',
                descricao: 'Código de autorização inválido'
              } as AppResponseError;
            }

            // Caso o token ou username de acesso exista é removido
            this.authService.clearStorage();
            // Verificação de link

            this.apiService.verificaCodigoAutorizacao(this.authCode, this.primeiroAcesso).subscribe({
              error: (error: AppResponseError) => {
                this.toastr.error(error.descricao, error.titulo);
                this.authCodeInvalido = true;
              }
            });
          } catch (e) {
            const err = e as AppResponseError;
            this.toastr.error(err.descricao, err.titulo);
          }
        },
        error: (err: AppResponseError) => {
          this.toastr.error(err.titulo, err.descricao);
        }
      });


  }

  savePassword() {

    // Caso o token ou username de acesso exista é removido
    this.authService.clearStorage();
    if (this.formPassword.invalid) {
      return;
    }

    this.apiService.definicaoSenha(this.formPassword.get('senha').value, this.authCode, this.primeiroAcesso)
      .subscribe((sucess: TokenLogin) => {
        this.toastr.success('Sua senha foi cadastrada', 'Sucesso');
        this.router.navigateByUrl('logon');
      },
        (error: AppResponseError) => {
          this.toastr.error(error.descricao, error.titulo);
        });
  }

  public get textoTooltipSenhas() : string {
    return TEXTO_TOOLTIP_SENHAS
  }

  get primeiroAcesso(){
    return this.tipo === 'DefinirSenha';
  }
}
